import { DataBean } from "../DataBean";

interface configuration {
  disableSpinner?: boolean;
}

export class Inbox extends DataBean {
  public async getBpmInboxForAssing(
    idlnFunctinalID: number,
    idroles: any,
    activityTypes: any,
    stateImp: number,
    page: number,
    row: number
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "java.util.List_getBpmInboxForAssing_Number_java.util.List_java.util.List_Number_Number_Number",
      [idlnFunctinalID, idroles, activityTypes, stateImp, page, row]
    );
  }

  public async getProcedureImpForAssignVerifyWorkMember(
    idWorkGroupMember: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "com.advantage.shared.Report_getProcedureImpForAssignVerifyWorkMember_Number_Number_Number",
      [idWorkGroupMember, page, recordsPerPage]
    );
  }

  public async getListBpmInboxForAssing(
    idlnFunctinalID: number,
    idroles: any,
    activityTypes: any,
    stateImp: number,
    page: number,
    row: number
  ): Promise<any> {
    return this.getCustomService(
      "CacheOptions",
      "com.advantage.shared.Report_getListBpmInboxForAssing_Number_java.util.List_java.util.List_Number_Number_Number",
      [idlnFunctinalID, idroles, activityTypes, stateImp, page, row]
    );
  }

  public async assignProcedureImpToGroupMember(
    idProcedureImp: number,
    idAccount: number,
    idAllocator: number
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "Number_assignProcedureImpToGroupMember_Number_Number_Number",
      [idProcedureImp, idAccount, idAllocator]
    );
  }

  public async getProcedureImpForVerify(idAccount: number): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureImpForVerify_Number",
      [idAccount]
    );
  }

  public async getProcedureActionForVerify(
    idAccount: number,
    idProcedureImp: number
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureActionForVerify_Number_Number",
      [idAccount, idProcedureImp]
    );
  }

  public async verifyProcedureAction(
    idProcedureAction: number,
    description: string
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "boolean_verifyProcedureAction_Number_String",
      [idProcedureAction, description]
    );
  }

  public async declineProcedureAction(
    idProcedureAction: number,
    description: string
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "boolean_declineProcedureAction_Number_String",
      [idProcedureAction, description]
    );
  }

  public async getProcedureImpForResponse(idAccount: number): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureImpForResponse_Number",
      [idAccount]
    );
  }
  public async getProcedureImpForResponseReport(idAccount:number,page: number,rows:number,props:any): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "com.advantage.shared.Report_getProcedureImpForResponseReport_Number_Number_Number_java.util.Map",
      [idAccount,page,rows,props]
    );
  }

  public async getProcedureActionByAccount(
    idAccount: number,
    idProcedureImp: number,
    type: number
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureActionByAccount_Number_Number_Number",
      [idAccount, idProcedureImp, type]
    );
  }

  public async responseProcedureAction(
    idProcedureAction: number,
    description: string,
    responseValue: boolean,
    responseValues: any,
    test: boolean,
    configService?: configuration
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "com.quickbpm.bean.ResponseValue_responseProcedureAction_Number_String_Boolean_java.util.Map_Boolean",
      [idProcedureAction, description, responseValue, responseValues, test],
      configService
    );
  }

  public async getDocumentsByProcedureImp(
    idProcedureImp: number
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getDocumentsByProcedureImp_Number",
      [idProcedureImp]
    );
  }

  public async getWorkGroupRoleCatalog(idWorkGroupMember): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getWorkGroupRoleCatalog_Number",
      [idWorkGroupMember]
    );
  }

  public async getRequestProcessBpmByImp(idProcedureImp: number): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_getRequestProcessBpmByImp_Number",
      [idProcedureImp]
    );
  }

  public async deletePropsRequestProcessBpm(
    idProcedureImp: number,
    listNames: any
  ): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_deletePropsRequestProcessBpm_Number_java.util.List",
      [idProcedureImp, listNames]
    );
  }

  public async cancelProcedureImp(
    idProcedureImp: number,
    idAccount: number,
    description: string
  ): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "boolean_cancelProcedureImp_Number_Number_String",
      [idProcedureImp, idAccount, description]
    );
  }

  public async pushRequestProcessBpm(
    idProcedureImp: number,
    props: any,
    configService?: configuration
  ): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_pushRequestProcessBpm_Number_java.util.Map",
      [idProcedureImp, props],
      configService
    );
  }

  public async getResumeBpmByImp(idProcedureImp: number): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_getResumeBpmByImp_Number",
      [idProcedureImp]
    );
  }

  public async getProcedureImpByAccount(idAccount: number): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureImpByAccount_Number",
      [idAccount]
    );
  }

  public async getProcedureImpByAlphaCode(code: any): Promise<any> {
    return this.getCustomService(
      "BpmService",
      "java.util.List_getProcedureImpByAlphaCode_String",
      [code]
    );
  }
  public async updateRequestProcessBpm(bean: any): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_updateRequestProcessBpm_com.orange.bean.RequestProcessBpm",
      [{
        DataBeanProperties:bean,
        DataBeanName:"com.orange.bean.RequestProcessBpm"
      }]
    );
  }

  public async pushResumeBpm(
    idProcedureImp: number,
    idEmployee: number,
    resumen: string,
    configService?: configuration
  ): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.orange.bean.RequestProcessBpm_pushResumeBpm_Number_Number_String",
      [idProcedureImp, idEmployee, resumen],
      configService
    );
  }
}
